module.exports = __webpack_public_path__ + "media/images/icons/flags/TM-61e5bafe0495db49edc40a8bc4a3b521.svg";